import { Loader } from '@anex/common';
import { Field, Form, withFormik } from 'formik';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { AlertContainer, Error } from '../../../../components';
import { ContractInfo } from './components/ContractInfo';
import { SuccessInfo } from './components/SuccessInfo';
import { Disclaimer } from './components/Disclaimer';
var SelectPlanForm = observer(function (props) {
    var config = props.config, planStore = props.planStore, checkAddressStore = props.checkAddressStore, setFieldValue = props.setFieldValue, errors = props.errors, values = props.values;
    var _a = React.useState([]), planLengths = _a[0], setPlanLengths = _a[1];
    var _b = React.useState([]), plans = _b[0], setPlans = _b[1];
    React.useEffect(function () {
        processPlanDetails();
    }, []);
    React.useEffect(function () {
        props.summaryStore.getSummary(props.values.contractCode, '', props.checkAddressStore.nbnLocId, '', null);
    }, [props.values.contractCode]);
    React.useEffect(function () {
        if (checkAddressStore.qualificationResponse) {
            processPlanDetails();
        }
    }, [checkAddressStore.qualificationResponse]);
    React.useEffect(function () {
        if (checkAddressStore.sqAddressResponse) {
            checkAddressStore.loading = true;
            processPlanDetails();
            checkAddressStore.loading = false;
        }
    }, [checkAddressStore.upgardeSelected]);
    function processPlanDetails() {
        var planCode = planStore.planCode;
        var allPlans = planStore.getPlans();
        var lengths = Array.from(new Set(allPlans.map(function (p) { return p.length; })));
        setPlanLengths(lengths);
        if (checkAddressStore.upgardeSelected) {
            console.log('upgrade processing');
            var minimumDownloadSpeed = checkAddressStore.sqAddressResponse.sqSummary.nbn
                .alternativeTechnologyDetails.minimumDownloadSpeed;
            var minimumUploadSpeed = checkAddressStore.sqAddressResponse.sqSummary.nbn
                .alternativeTechnologyDetails.minimumUploadSpeed;
            if (minimumDownloadSpeed != null && minimumUploadSpeed != null) {
                var filterPlans = allPlans.filter(function (p) {
                    return p.baseSpeedInKb >= minimumDownloadSpeed * 1024 &&
                        p.baseSpeedOutKb >= minimumUploadSpeed * 1024;
                });
                console.log('filterPlans', filterPlans);
                setPlans(filterPlans);
            }
            else
                setPlans(allPlans);
        }
        else {
            var maxDownloadSpeed = checkAddressStore.maximumDownloadSpeed;
            var maxUploadSpeed = checkAddressStore.maximumUploadSpeed;
            if (maxDownloadSpeed != null && maxUploadSpeed != null) {
                var filterPlans = allPlans.filter(function (p) {
                    return p.baseSpeedInKb <= maxDownloadSpeed &&
                        p.baseSpeedOutKb <= maxUploadSpeed;
                });
                console.log('filterPlans', filterPlans);
                setPlans(filterPlans);
            }
            else if (maxDownloadSpeed != null && maxUploadSpeed == null) {
                var filterPlans = allPlans.filter(function (p) { return p.baseSpeedInKb <= maxDownloadSpeed; });
                setPlans(filterPlans);
            }
            else
                setPlans(allPlans);
        }
        if (planCode && !values['contractCode']) {
            var selectedPlan = allPlans.find(function (p) { return p.code === planCode; });
            if (selectedPlan) {
                var typePlan = selectedPlan.planType;
                setFieldValue('planType', typePlan);
                setFieldValue('contractCode', planCode);
                planStore.setPlanByType(typePlan, planCode);
            }
            else {
                var plans_1 = planStore.plans;
                var i = plans_1
                    ? plans_1.findIndex(function (j) { return j.code === planCode; })
                    : -1;
                setFieldValue('planType', i > -1 ? plans_1[i].planType : '');
            }
        }
        else if (!planCode) {
            var plans_2 = planStore.plans;
            var i = plans_2
                ? plans_2.findIndex(function (j) { return j.code === planCode; })
                : -1;
            setFieldValue('planType', i > -1 ? plans_2[i].planType : '');
        }
    }
    function renderPlans() {
        return planLengths.map(function (length) { return (React.createElement("optgroup", { key: "lngth-#{length}", label: length === 0
                ? 'Month to month, no lock in contract'
                : '24 Month Contract' }, plans
            .filter(function (plan) { return plan.length === length; })
            .sort(function (a, b) { return a.baseSpeedInKb - b.baseSpeedInKb; })
            .map(function (p, i) { return (React.createElement("option", { key: p.code, id: i.toString(), value: p.code, "data-plantype": p.planType ? p.planType : '' }, p.name)); }))); });
    }
    function onSelectPlan(e) {
        var planType = e.currentTarget[e.currentTarget.selectedIndex].getAttribute('data-plantype');
        setFieldValue('planType', planType);
        setFieldValue('contractCode', e.currentTarget.value);
    }
    var wholesalerName = '';
    if (config && config.wholesaleCustomerCode === 'TOM') {
        wholesalerName = 'Tomi';
    }
    return (React.createElement(Form, null,
        React.createElement(Loader, { loading: checkAddressStore.loading, text: "Please wait, processing your upgrade request.." }),
        React.createElement(SuccessInfo, null),
        React.createElement("hr", null),
        React.createElement(AlertContainer, null),
        planStore.plans !== null && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "w-100" },
                React.createElement("label", { htmlFor: "contractCode", className: "w-100" },
                    "Select a plan:",
                    React.createElement(Field, { id: "contractCode", name: "contractCode", component: "select", className: "form-control select-inline shadow-alt " + (errors.contractCode &&
                            'error'), value: values.contractCode, onChange: onSelectPlan },
                        React.createElement("option", { value: "" }, "Please select a plan"),
                        renderPlans()),
                    React.createElement(Error, { name: "contractCode" }),
                    React.createElement("br", null))),
            values.contractCode && (React.createElement("div", { className: "w-100" },
                React.createElement(ContractInfo, { plan: planStore.getContract(values.contractCode) }))))),
        React.createElement("br", null),
        React.createElement(Disclaimer, { wholesaler: wholesalerName }),
        React.createElement("section", { className: "footer-buttons" },
            React.createElement("button", { type: "submit", className: "btn btn-next" }, "Next"))));
});
export var SelectPlan = inject('checkAddressStore', 'appStore', 'summaryStore', 'saleStore', 'planStore', 'config')(withFormik({
    handleSubmit: function (values, bag) {
        bag.props.planStore.setDetailsFromForm(values);
        bag.props.appStore.nextStep();
    },
    mapPropsToValues: function (_a) {
        var planStore = _a.planStore;
        return planStore.planDetails.formValues
            ? planStore.planDetails.formValues
            : planStore.planDetails.formInitialValues;
    },
    validate: function (values) {
        var errors = {};
        if (!values['contractCode']) {
            errors.contractCode = 'Please select a contract';
        }
        return errors;
    },
})(SelectPlanForm));
//# sourceMappingURL=SelectPlan.js.map